import { render } from "./DrYouSix.vue?vue&type=template&id=b6ef8e0e&scoped=true"
import script from "./DrYouSix.vue?vue&type=script&lang=js"
export * from "./DrYouSix.vue?vue&type=script&lang=js"

import "./DrYouSix.vue?vue&type=style&index=0&id=b6ef8e0e&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ef8e0e"]])

export default __exports__